module.exports = __webpack_public_path__ + "img/image1-fallback.2de3edb3.jpg";